import React from 'react';
import CardsPage from '../../pages/spend-management/cards';
import ProtectedRoute from '../protected';

export const CardRoutes = [
  <ProtectedRoute exact path='/cards' component={CardsPage} />
] 